import {Component, OnInit, ViewChild} from '@angular/core';
import {Grid, GridSearchItem, ServiceSearchItem} from '../../../../shared/Models/grid';
import {Router} from '@angular/router';
import {DealerDashboardService} from '../../../Services/dealer-dashboard.service';
import {TranslateService} from '@ngx-translate/core';
import {BroadcastService} from '../../../../shared/Services/broadcast.service';
import {LanguageService} from '../../../../translation/Services/language.service';
import {ActionColumn, ActionItem, NumberColumn, TextColumn} from '../../../../shared/Models/columns';

@Component({
  selector: 'app-archive-dealer-dashboard',
  templateUrl: './archive-dealer-dashboard.component.html',
  styleUrls: ['./archive-dealer-dashboard.component.scss']
})
export class ArchiveDealerDashboardComponent implements OnInit {

  public grid: Grid;
  public blockId: number;
  public blockTitle: string;
  @ViewChild('readdModal', {static: false}) readdModal = null;

  constructor(
    private router: Router,
    private dealerDashboardService: DealerDashboardService,
    private translateService: TranslateService,
    private broadCastService: BroadcastService,
    private languageService: LanguageService,
  ) {
  }

  ngOnInit() {
    this.grid = <Grid>{
      columns: [
        <TextColumn>{
          name: 'doctrine.dealer_dashboard.title',
          prop: 'title',
          sortable: true,
          type: TextColumn.type,
          width: 300,
          translate: true,
        },
        <TextColumn>{
          name: 'doctrine.dealer_dashboard.language',
          prop: 'language.name',
          sortable: false,
          type: TextColumn.type,
          translate: true,
        },
        <TextColumn>{
          name: 'global.status',
          prop: 'status',
          sortable: false,
          type: TextColumn.type,
          translate: true,
          valueFormatter: row => {
            switch (row) {
              case true:
                return this.translateService.instant('global.active');
              case false:
                return this.translateService.instant('global.inactive');
            }
          }
        },
        <ActionColumn>{
          name: 'global.actions',
          prop: null,
          type: ActionColumn.type,
          sortable: false,
          translate: true,
          actionItems: [
            <ActionItem>{
              icon: 'feather icon-plus',
              tooltip: 'global.readd',
              onclick: row => {
                this.blockId = row.id;
                this.blockTitle = row.title.bold();
                this.readdModal.show();
              },
              showCallback: row => row,
              btnClass: 'ripple light'
            },
          ]
        },
      ],
      service: this.dealerDashboardService,
      rememberURL: this.router.url,
      method: 'getBlocks',
      defaultSort: 'title',
      rowDetailShowCallback: (row, size) => size < 1400,
      defaultSortType: 'desc',
      showButton: true,
      doseNotHaveSearch: true,
      archive: true,
      search: [
        <GridSearchItem>{
          name: 'language',
          type: 'ng-select',
          hasCalendar: false,
          hasDropdownListFilter: true,
          hasNormalSearch: true,
          label: 'doctrine.download.language_name',
          hasStatus: false,
          value: new ServiceSearchItem(this.languageService, 'list', {sortType: 'ASC', sortBy: 'name'}, (res) => {
            const options = [];
            options.push({value: 'all', label: this.translateService.instant('global.all')});
            for (const row of res.languages) {
              options.push({value: row.name, label: row.name});
            }
            return options;
          })
        }
      ],
    };
  }

  readdBlock() {
    this.dealerDashboardService.reAdd(this.blockId).subscribe((res) => {
      this.readdModal.hide();
      this.broadCastService.broadcast('refreshGrid', 'getBlocks');
    });
  }
}
